export const DEFAULT_REDIRECT_URI = 'http://www.lessonplay.cn'
export const PASSPORT_SERVER = 'https://passport.lessonplan.cn'
export const PASSPORT_CLIENT_SERVER = 'https://clientpassport.lessonplan.cn'
export const WX_OPEN_SERVER = 'https://open.weixin.qq.com'
export const Tsinghua_REDIRECT_URI = 'https://tsinghuashow.lessonplan.cn'
export const LESSONPLAY_TOKEN = "LESSONPLAY_TOKEN";
export const IMGURL = 'https://img.lessonplan.cn';
export const CDNURL = 'https://cdn.lessonplan.cn';

export const ONLINEURL = 'https://jc.sklib.cn'; //书店1
//export const ONLINEURL = 'https://jc1.sklib.cn'; //书店2

export const TextbookReader = 'https://textbook-reader.lessonplan.cn';

export const CODEVIEWURL = 'https://digital-textbook.lessonplan.cn';